import * as React from 'react';
import Sidebar from '../navigation/Sidebar';
import ReLoginComponent from '../auth/ReLoginComponent';
import { IdleState } from '../idle/Types';
import Header from '../header/Header';
import { SIDEBAR_MAX_WIDTH } from '../navigation/Constants';
import './commonFeature.css';
import { ScreenWidth } from '../app/app.const';
import { renderBrowserWarningMessage, isBrowserNotSupported } from './BrowserWarning';
import FreshChat from 'react-freshchat';
import { AuthState } from 'src/auth/auth.types';
import { BusinessState } from 'src/business/business.types';

type Props = {
  readonly idleState: IdleState
  readonly authState: AuthState
  readonly businessState: BusinessState
};

type States = {
  readonly screenWidth: number
  readonly screenHeight: number
  readonly sidebarOpen: boolean
  readonly isBrowserNotSupported: boolean
};

class CommonFeaturesComponent extends React.Component<Props, States> {
  
  constructor(props: Props) {
    super(props);

    this.state = {
      screenWidth: window.innerWidth,
      screenHeight: 0,
      sidebarOpen: false,
      isBrowserNotSupported: false
    };
  }

  componentDidMount() {
    this.setState(
      {isBrowserNotSupported: isBrowserNotSupported()},
      () => {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
      }
    );
  }
  
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  render() {
    let isMobile: boolean = this.state.screenWidth <= ScreenWidth.Large;
    return(
      <div>
        <ReLoginComponent reLoginModalOpen={this.props.idleState.expired} />
        <Sidebar
          isMobile={isMobile}
          open={this.state.sidebarOpen}
          toggleSidebarHandler={this.toggleSidebarHandler}
        />
        <div
          style={{
            backgroundColor: '#F1F1F1',
            minHeight: '100vh'
          }}
        >
          <Header toggleSidebarHandler={this.toggleSidebarHandler} />
          {renderBrowserWarningMessage(this.state.isBrowserNotSupported, true)}
          <div
            id="CommonBody"
            style={{
              marginLeft: (isMobile) ? 0 : SIDEBAR_MAX_WIDTH,
              paddingTop: 3
            }}
          >
            {this.props.children}
          </div>
        </div>
        {
          this.props.authState && this.props.businessState &&
           this.props.authState.account && this.props.businessState.business ?
          <FreshChat
            token="abc479b7-29ec-49b8-b7b2-3724a15f97d1"
            onInit={widget => {
              widget.user.setProperties(
                {
                  email: this.props.authState.email,
                  first_name: this.props.authState.account.firstName,
                  last_name: this.props.authState.account.lastName,
                  business: this.props.businessState.business.name
                }
              );
            }

            }
          /> : null
        }
      </div>
    );
  }
  
  updateWindowDimensions = (): void => {
    this.setState({ screenWidth: window.innerWidth, screenHeight: window.innerHeight });
  }

  toggleSidebarHandler = (): void => {
    this.setState({ sidebarOpen: !this.state.sidebarOpen });
  }
}

export default CommonFeaturesComponent;



// WEBPACK FOOTER //
// ./src/commons/CommonFeaturesComponent.tsx